package one.healthium.tutorial.di

import one.healthium.onboarding.di.onboardingCommonModule
import org.koin.dsl.module

val tutorialUiModule = module {
    includes(onboardingCommonModule, tutorialDataModule)
}